import getConfig from 'next/config';
import _ from 'lodash';

const config = getConfig();

function parseJSON(str, fallback = {}) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return fallback;
  }
}

export const isClient = typeof window !== 'undefined'
export const isServer = !isClient

// ENV VARS
export const API_URL = _.get(config, 'publicRuntimeConfig.API_URL', process.env.API_URL);
export const OAUTH_SERVER_URL = _.get(
  config,
  'publicRuntimeConfig.OAUTH_SERVER_URL',
  process.env.OAUTH_SERVER_URL || API_URL
);
export const DOMAIN = _.get(config, 'publicRuntimeConfig.DOMAIN', process.env.DOMAIN);
export const EXTREME_POINTS_CONFIG = parseJSON(
  _.get(config, 'publicRuntimeConfig.EXTREME_POINTS_CONFIG', process.env.EXTREME_POINTS_CONFIG)
);
export const FACEBOOK_OAUTH_CLIENT_ID = _.get(
  config,
  'publicRuntimeConfig.FACEBOOK_OAUTH_CLIENT_ID',
  process.env.FACEBOOK_OAUTH_CLIENT_ID
);
export const NODE_ENV = _.get(config, 'publicRuntimeConfig.NODE_ENV', process.env.NODE_ENV);
export const REMOTASKS_FRONTEND_URL = _.get(
  config,
  'publicRuntimeConfig.REMOTASKS_FRONTEND_URL',
  process.env.REMOTASKS_FRONTEND_URL
);
export const REMOTASKS_FRONTEND_PROD_URL = _.get(
  config,
  'publicRuntimeConfig.REMOTASKS_FRONTEND_PROD_URL',
  process.env.REMOTASKS_FRONTEND_PROD_URL
);
export const SCALE_FRONTEND_URL = _.get(
  config,
  'publicRuntimeConfig.SCALE_FRONTEND_URL',
  process.env.SCALE_FRONTEND_URL
);
export const SCALE_FRONTEND_PROD_URL = _.get(
  config,
  'publicRuntimeConfig.SCALE_FRONTEND_PROD_URL',
  process.env.SCALE_FRONTEND_PROD_URL
);
export const SCALE_DASHBOARD_FRONTEND_URL = _.get(
  config,
  'publicRuntimeConfig.SCALE_DASHBOARD_FRONTEND_URL',
  process.env.SCALE_DASHBOARD_FRONTEND_URL
);
export const SCALE_DASHBOARD_FRONTEND_PROD_URL = _.get(
  config,
  'publicRuntimeConfig.SCALE_DASHBOARD_FRONTEND_PROD_URL',
  process.env.SCALE_DASHBOARD_FRONTEND_PROD_URL
);
export const NEW_RELIC_APP_NAME = _.get(
  config,
  'publicRuntimeConfig.NEW_RELIC_APP_NAME',
  process.env.NEW_RELIC_APP_NAME
);
export const SEGMENT_KEY_CORP = _.get(
  config,
  'publicRuntimeConfig.SEGMENT_KEY_CORP',
  process.env.SEGMENT_KEY_CORP
);
export const SEGMENT_KEY_CUSTOMERS = _.get(
  config,
  'publicRuntimeConfig.SEGMENT_KEY_CUSTOMERS',
  process.env.SEGMENT_KEY_CUSTOMERS
);
export const SEGMENT_KEY_SCALERS = _.get(
  config,
  'publicRuntimeConfig.SEGMENT_KEY_SCALERS',
  process.env.SEGMENT_KEY_SCALERS
);
export const STRIPE_KEY = _.get(config, 'publicRuntimeConfig.STRIPE_KEY', process.env.STRIPE_KEY);
export const SENTRY_DSN = _.get(config, 'publicRuntimeConfig.SENTRY_DSN', process.env.SENTRY_DSN);
export const EB_APP_NAME = _.get(
  config,
  'publicRuntimeConfig.EB_APP_NAME',
  process.env.EB_APP_NAME
);
export const EB_ENV_NAME = _.get(
  config,
  'publicRuntimeConfig.EB_ENV_NAME',
  process.env.EB_ENV_NAME
);
export const EB_ENV_ID = _.get(config, 'publicRuntimeConfig.EB_ENV_ID', process.env.EB_ENV_ID);
export const AWS_REGION = _.get(config, 'publicRuntimeConfig.AWS_REGION', process.env.AWS_REGION);
export const STACK = _.get(config, 'publicRuntimeConfig.STACK', process.env.STACK);
export const DATADOG_CLIENT_TOKEN = _.get(
  config,
  'publicRuntimeConfig.DATADOG_CLIENT_TOKEN',
  process.env.DATADOG_CLIENT_TOKEN
);

// RUNTIME

export const IS_PROD = NODE_ENV === 'production';
export const IS_DEV = NODE_ENV === 'development';
export const IS_E2E = NODE_ENV === 'production' && (API_URL || '').includes('localhost');

export const IS_REMOTASKS_FRONTEND = (REMOTASKS_FRONTEND_URL || '').includes(DOMAIN);
export const IS_SCALE_FRONTEND = (SCALE_FRONTEND_URL || '').includes(DOMAIN);

export const SKIP_CATEGORIES = {
  platform: 'Remotasks error',
  task: 'Difficult task',
  content: 'Inappropriate content'
};

export const SKIP_REASONS = {
  platform: {
    task_loading: "Task doesn't load correctly",
    instructions_loading: "Instructions don't load or are hard to read",
    error_claiming: 'Somebody else is working on this task',
    error_submitting: 'I get an unexpected error when trying to submit'
  },

  task: {
    edge_case: 'Instructions are unclear about this situation',
    image_quality: 'The image is fuzzy or has low quality',
    task_difficulty: 'Not sure how to correctly complete task',
    qa_difficulty: 'Not sure how to fix automatically-detected mistakes',
    task_length: 'Task would take too long'
  },

  content: {
    explicit: 'Task contains sexually explicit content',
    violence: 'Task depicts violence and/or criminal activity',
    content_other: 'Task contains other inappropriate or disturbing content'
  }
};

// DATOCMS

export const EXAMPLE_PATH = 'cms-datocms';
export const CMS_NAME = 'DatoCMS';
export const CMS_URL = 'https://www.datocms.com/';
export const HOME_OG_IMAGE_URL =
  'https://og-image.vercel.app/Next.js%20Blog%20Example%20with%20**DatoCMS**.png?theme=light&md=1&fontSize=75px&images=https%3A%2F%2Fassets.vercel.com%2Fimage%2Fupload%2Ffront%2Fassets%2Fdesign%2Fnextjs-black-logo.svg&images=data%3Aimage%2Fsvg%2Bxml%3Bbase64%2CPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMjYxLjI3NCA4MC41NjIiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iYSIgeTE9IjQwLjQ0IiB4Mj0iNzguNjg3IiB5Mj0iNDAuNDQiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZjU5M2QiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNmZjc3NTEiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48dGl0bGU%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%2BPC9zdmc%2B&widths=undefined&widths=350&heights=200&heights=auto';

export const isDev = process.env.NODE_ENV === 'development';

// Be sure to include Vercel System Env Vars
export const originURL = isDev
  ? 'http://localhost:3000'
  : `https://${process.env.VERCEL_URL ?? process.env.NEXT_PUBLIC_VERCEL_URL}`;
